import { Link } from 'react-router-dom';
import Helmet from '@/components/base/Helmet';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CTASection from '@/pages/home/components/CTASection';
import { brandInfo, userComments } from '@/mocks/site';

const ABOUT_HERO = 'https://readdy.ai/api/search-image?query=Modern%20journalism%20newsroom%20with%20dramatic%20warm%20lighting%2C%20professional%20broadcast%20equipment%20and%20multiple%20screens%2C%20editorial%20office%20atmosphere%20with%20wooden%20desks%20and%20ambient%20glow%2C%20sophisticated%20media%20company%20interior%20design%2C%20professional%20documentary%20photography%20style&width=1600&height=400&seq=about-hero&orientation=landscape';

export default function AboutPage() {
  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: `关于我们 - ${brandInfo.name}`,
    description: brandInfo.description,
    url: 'http://mengwenquda.cn/about',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: brandInfo.name,
    url: 'http://mengwenquda.cn/',
    description: brandInfo.description,
    foundingDate: brandInfo.founded,
    email: brandInfo.email,
    telephone: brandInfo.phone,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      streetAddress: '望京SOHO',
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'http://mengwenquda.cn/' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://mengwenquda.cn/about' },
    ],
  };

  return (
    <>
      <Helmet title={`关于我们 - ${brandInfo.name}`} />
      <Helmet>
        {`<meta name="description" content="${brandInfo.description}" />`}
        {`<meta name="keywords" content="关于我们,黑料爆料吃瓜网,品牌介绍,联系我们" />`}
        {`<link rel="canonical" href="http://mengwenquda.cn/about" />`}
        {`<script type="application/ld+json">${JSON.stringify(aboutSchema)}</script>`}
        {`<script type="application/ld+json">${JSON.stringify(orgSchema)}</script>`}
        {`<script type="application/ld+json">${JSON.stringify(breadcrumbSchema)}</script>`}
      </Helmet>

      <Navbar />

      <main>
        <div className="relative w-full h-[320px] md:h-[400px] overflow-hidden">
          <img
            src={ABOUT_HERO}
            alt="关于我们"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>
          <div className="relative z-10 h-full flex flex-col justify-center px-4 md:px-6 pt-16">
            <div className="max-w-7xl mx-auto w-full text-center">
              <nav className="flex items-center justify-center gap-2 text-white/60 text-xs mb-4 flex-wrap">
                <Link to="/" className="hover:text-white transition-colors whitespace-nowrap">首页</Link>
                <i className="ri-arrow-right-s-line text-[10px]"></i>
                <span className="text-white font-medium whitespace-nowrap">关于我们</span>
              </nav>
              <h1 className="font-heading text-2xl md:text-4xl font-black text-white">
                关于黑料爆料吃瓜网
              </h1>
              <p className="text-white/70 text-sm mt-2 max-w-lg mx-auto">
                {brandInfo.slogan}
              </p>
            </div>
          </div>
        </div>

        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full border border-foreground-300 text-xs font-medium text-foreground-700 mb-6 whitespace-nowrap">
              品牌介绍
            </div>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-6 leading-tight">
              全网热门黑料爆料
              <br />
              <span className="text-primary-600">一网打尽，速来吃瓜</span>
            </h2>
            <p className="text-foreground-600 text-sm leading-relaxed max-w-2xl mx-auto">
              {brandInfo.description}
            </p>
            <p className="text-foreground-600 text-sm leading-relaxed max-w-2xl mx-auto mt-4">
              我们的编辑团队由一群热爱吃瓜、追求真相的资深媒体人组成，24小时不间断追踪全网热点，
              确保每一位吃瓜群众都能第一时间获取最新、最劲爆的黑料爆料。从网红塌房到明星聊天记录泄露，
              从博主反差视频到51吃瓜黑料爆料、17c吃瓜黑料爆料，我们始终坚持真实、客观、快速的原则。
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12">
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                  <i className="ri-flashlight-line text-xl"></i>
                </div>
                <h3 className="font-semibold text-sm text-foreground-900 mb-1">快速爆料</h3>
                <p className="text-xs text-foreground-600">7&times;24小时实时追踪，第一时间呈现最新黑料</p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-shield-check-line text-xl"></i>
                </div>
                <h3 className="font-semibold text-sm text-foreground-900 mb-1">真实可靠</h3>
                <p className="text-xs text-foreground-600">严格核实信息来源，确保每一条爆料真实可信</p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-3">
                  <i className="ri-group-line text-xl"></i>
                </div>
                <h3 className="font-semibold text-sm text-foreground-900 mb-1">吃瓜社区</h3>
                <p className="text-xs text-foreground-600">汇聚千万吃瓜群众，一起讨论最热黑料话题</p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-1 text-xs text-foreground-500 mb-2">
                <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                口碑评价
              </div>
              <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
                吃瓜群众信赖之选
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {userComments.slice(0, 4).map((comment) => (
                <div key={comment.id} className="bg-background-50 rounded-lg p-5 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-xs text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
                  <div className="flex items-center gap-2.5">
                    <img src={comment.avatar} alt={comment.username} className="w-8 h-8 rounded-full object-cover" />
                    <div>
                      <p className="text-xs font-semibold text-foreground-900">{comment.username}</p>
                      <p className="text-[10px] text-foreground-500">{comment.date}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-14 md:py-20 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full border border-foreground-300 text-xs font-medium text-foreground-700 mb-6 whitespace-nowrap">
                联系我们
              </div>
              <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
                有料就爆，联系我们
              </h2>
              <p className="text-foreground-600 text-sm max-w-lg mx-auto">
                如果你有劲爆的线索或独家爆料，欢迎通过以下方式联系我们
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <h3 className="font-semibold text-sm text-foreground-900 mb-1">爆料邮箱</h3>
                <p className="text-xs text-foreground-600">{brandInfo.email}</p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                <h3 className="font-semibold text-sm text-foreground-900 mb-1">联系电话</h3>
                <p className="text-xs text-foreground-600">{brandInfo.phone}</p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-3">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <h3 className="font-semibold text-sm text-foreground-900 mb-1">公司地址</h3>
                <p className="text-xs text-foreground-600">{brandInfo.address}</p>
              </div>
            </div>
          </div>
        </section>

        <CTASection />
      </main>

      <Footer />
    </>
  );
}